export default function onLogout() {}
